module.exports = __webpack_public_path__ + "img/7b53c15.png";